import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BaseDialog} from "../BaseDialog";
import {IManagableObject} from "../IManagableObject";
import {TranslateService} from "@ngx-translate/core";
import { ContainerViewModel } from "../ContainerViewModel";

type GroupManagementObject = IManagableObject & {
  ContainerId?: number;
};

@Component({
    selector: 'app-group-management-dialog',
    templateUrl: './group-management-dialog.component.html',
    styleUrls: ['./group-management-dialog.component.css'],
    standalone: false
})
export class GroupManagementDialogComponent extends BaseDialog implements OnInit {
  constructor(private translate:TranslateService) {
    super();
    this.dialogId = 'groupMgmtDialog'
  }

  @Output() onAddObjects: EventEmitter<any> = new EventEmitter();

  public object: GroupManagementObject = new class implements GroupManagementObject {
    IsChecked: boolean;
    Id: number;
    Name: string;
    ContainerId?: number;
  };

  public containers: ContainerViewModel[] = [];
  public readonlyContainer: boolean = false;

  public deleteObject(object: IManagableObject) {
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + object.Name + "?")) return;
    this.doDeleteObject(object);
  }

  private doDeleteObject(object :IManagableObject) {
    let idx = this.objects.indexOf(object);
    if (idx < 0) return;
    this.objects.splice(idx, 1);
    object.IsChecked = false;
    this.selectObjectsCount = this.objects.filter(c => c.IsChecked).length;
  }

  public deleteSelected() {

    let items = this.objects.filter(c => c.IsChecked);
    if (items.length == 0) return;
    let message = this.translate.instant("Delete selected items?");
    if (!confirm(message)) return;
    items.forEach((command) => {
      this.doDeleteObject(command);
    });
  }

  public addObjects() {
    this.onAddObjects.emit();
  }

  public open(model: any) {
    if (model)
      this.object = model as GroupManagementObject;
    super.open(model);
  }

  public getSelectedContainerName(): string {
    const containerId = this.object?.ContainerId;
    if (!containerId) return "";
    return this.containers.find(x => x.Id === containerId)?.Name ?? "";
  }

  ngOnInit(): void {
  }
}
